import {Stack, SxProps, Theme, Typography, useTheme} from "@mui/material";
import React from "react";
import {UserProfile} from "../../common/models/userProfile/userProfile.model";
import UserSearchField from "./userSearchField";

interface SearchProps {
    backgroundColor?: string;
    sx?: SxProps<Theme>;
    onSubmitted?: (user: UserProfile) => void;
}

const UserComparisonSearch = (props: SearchProps) => 
{
    const {
        backgroundColor,
        sx,
    } = props;

    const theme = useTheme();

    return (
        <Stack
            bgcolor={backgroundColor}
            py={2}
            px={1.5}
            borderRadius={0.5}
            sx={sx}
        >
            <Typography
                variant={"body1"}
                fontWeight={"bold"}
                color={theme.palette.thatsMe.textTitle}
                alignSelf={"start"}
                pb={2}
            >
                Try with another user
            </Typography>
            <UserSearchField/>
        </Stack>
    );
}

export default UserComparisonSearch